import React from "react";
import "../styles/_accomodation.scss";
interface Props {}

const Accomodation: React.FC<Props> = (props) => {
  return (
    <div className="Accomodation padding100" id="accomodation">
      <div className="container">
        <h6>AL-MARE</h6>
        <h1>ACCOMODATION</h1>
        <div className="row justify-content-evenly g-0">
          <div className="col-lg-4 my-lg-0 my-4 col-12 p-3">
            <div className="wrapper">
              <div className="proba">
                <img src="accomodation1.jpg" alt="" className="accImage" />
              </div>
              <div className="textWrapper">
                <h3 className="mb-3">Confortable</h3>
                <p>
                  Al-Mare belongs to the group of small family hotels, with a
                  total of 33 rooms. Each room is elegantly and functionally
                  furnished, which makes the stay pleasant and comfortable
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 my-lg-0 my-4 col-12  p-3">
            <div className="wrapper">
              <div className="proba">
                <img src="accomodation2.jpg" alt="" className="accImage" />
              </div>
              <div className="textWrapper">
                <h3 className="mb-3">Accommodation</h3>
                <p>
                  Each room is equipped with an air-conditioning system, toilet,
                  shower, satellite TV, fridge, and a separate balcony for each
                  room. The rooms also have wireless internet and the guests may
                  use the valuables deposit service.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-4 my-lg-0 my-4 col-12  p-3">
            <div className="wrapper">
              <div className="proba">
                <img src="accomodation3.jpg" alt="" className="accImage" />
              </div>
              <div className="textWrapper">
                <h3 className="mb-3">Breakfast</h3>
                <p>
                  The accommodation can be on BB (bed and breakfast) and HB
                  (half-board / breakfast and dinner) basis, in two and three
                  bed rooms, with a possibility of adding an auxiliary bed.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Accomodation;
